import { useState, useCallback } from 'react';

const useNotification = () => {
    const [notification, setNotification] = useState({
        message: '',
        type: 'info',
        isVisible: false
    });

    const showNotification = useCallback((message, type = 'info', duration = 3000) => {
        setNotification({
            message,
            type,
            isVisible: true
        });
    }, []);

    const hideNotification = useCallback(() => {
        setNotification(prev => ({
            ...prev,
            isVisible: false
        }));
    }, []);

    return {
        notification,
        showNotification,
        hideNotification
    };
};

export default useNotification;
